import {
  LAYOUT,
  useAllParticipants,
  useIsReconnecting,
  useLayout,
  useNonRecoverableError,
  useTranslation,
} from '@cometchat/calls-sdk-core';
import RemoteAudioRenderer from './audio/RemoteAudioRenderer.web';
import { ProcessingOverlay } from './processing-overlay/ProcessingOverlay';
import RecordingIndicator from './recording-indicator/RecordingIndicator';
import SidebarLayout from './sidebar-layout/SidebarLayout.web';
import Spotlight from './spotlight/Spotlight.web';
import { TileView } from './tile-grid/TileGrid.web';
import { type TileComponentProps } from './tile-grid/type';
import Tile from './tile/Tile.web';

const TileComponent = ({ index }: TileComponentProps) => {
  const participant = useAllParticipants()[index];
  return <Tile participant={participant} />;
};

function CallStage() {
  const participants = useAllParticipants();
  const layout = useLayout();
  const isReconnecting = useIsReconnecting();
  const nonRecoverableError = useNonRecoverableError();
  const { t } = useTranslation();

  if (participants.length <= 0) {
    return null;
  }

  return (
    <>
      {layout === LAYOUT.SPOTLIGHT && <Spotlight />}
      {layout === LAYOUT.SIDEBAR && <SidebarLayout />}
      {layout === LAYOUT.TILE && (
        <TileView
          listData={participants}
          TileComponent={TileComponent}
          keyExtractor={item => item.ruid}
        />
      )}
      {isReconnecting && (
        <ProcessingOverlay message="You've been disconnected. Attempting to reconnect…" />
      )}
      {nonRecoverableError && (
        <ProcessingOverlay
          message={t('general.error')}
          description={nonRecoverableError}
          showLoading={false}
        />
      )}
      <RecordingIndicator />
      <RemoteAudioRenderer />
    </>
  );
}

export default CallStage;
